import React, { useEffect, useState } from 'react';
import { Card, Col, Row, Form, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAward } from '@fortawesome/free-solid-svg-icons';
import FormResultMessage from './FormResultMessage';
import {
  fetchHVACampaigns,
  HVACampaign,
  fetchHVAScorecardCampaigns,
  assignScorecardCampaigns
} from 'services/hvaservicecampaign.service';
import {
  fetchHVAScorecards,
  HVAScorecard
} from 'services/hvascorecard.service';

const ScorecardAssignmentForm2: React.FC = () => {
  const [campaigns, setCampaigns] = useState<HVACampaign[]>([]);
  const [scorecards, setScorecards] = useState<HVAScorecard[]>([]);
  // eslint-disable-next-line
  const [selectedScorecard, setSelectedScorecard] = useState<number | null>(null);
  // eslint-disable-next-line
  const [selectedCampaigns, setSelectedCampaigns] = useState<Set<number>>(new Set());

  const [message, setMessage] = useState<string | null>(null);
  // eslint-disable-next-line
  const [messageType, setMessageType] = useState<'successupdate' | 'errorupdate'>('successupdate');
  const [modalVisible, setModalVisible] = useState<boolean>(false);

  // Carga campañas y scorecards
  useEffect(() => {
    const loadCampaigns = async () => {
      try {
        const campaignsData = await fetchHVACampaigns();
        setCampaigns(campaignsData);
      } catch (error) {
        console.error('Error loading campaigns:', error);
      }
    };

    const loadScorecards = async () => {
      try {
        const scorecardsData = await fetchHVAScorecards();
        setScorecards(scorecardsData);
      } catch (error) {
        console.error('Error loading scorecards:', error);
      }
    };

    loadCampaigns();
    loadScorecards();
  }, []);

  // Carga las campañas que usan una scorecard
  useEffect(() => {
    const loadScorecardCampaigns = async () => {
      if (selectedScorecard !== null) {
        try {
          // eslint-disable-next-line
          const scorecardCampaignIds = await fetchHVAScorecardCampaigns(selectedScorecard);
          setSelectedCampaigns(new Set(scorecardCampaignIds));
        } catch (error) {
          console.error('Error loading scorecard campaigns:', error);
          setSelectedCampaigns(new Set());
        }
      } else {
        setSelectedCampaigns(new Set());
      }
    };

    loadScorecardCampaigns();
  }, [selectedScorecard]);

  const handleScorecardSelect = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setSelectedScorecard(Number(event.target.value));
  };

  const handleCampaignSelect = (campaignId: number) => {
    setSelectedCampaigns(prevSelectedCampaigns => {
      const newSelectedCampaigns = new Set(prevSelectedCampaigns);
      if (newSelectedCampaigns.has(campaignId)) {
        newSelectedCampaigns.delete(campaignId);
      } else {
        newSelectedCampaigns.add(campaignId);
      }
      return newSelectedCampaigns;
    });
  };

  const handleAssign = async () => {
    if (selectedScorecard !== null) {
      try {
        await assignScorecardCampaigns(
          selectedScorecard,
          Array.from(selectedCampaigns)
        );
        // eslint-disable-next-line
        if (selectedCampaigns.size > 0) {
          setMessage(
            'Well done! The selected campaigns have been assigned to the scorecard.'
          );
        } else {
          setMessage('All campaigns have been removed from the scorecard.');
        }
        setMessageType('successupdate');
      } catch (error) {
        setMessage(
          'An error occurred while updating campaign assignments: ' + error
        );
        setMessageType('errorupdate');
      }
      setModalVisible(true);
    } else {
      alert('Please select a scorecard.');
    }
  };

  const closeModal = () => {
    setModalVisible(false);
  };

  return (
    <Row className="p-0">
      <Col className="">
        <h3 className="px-2 text-secondary-darker">Scorecards</h3>
        <Card className="bg-body">
          <Card.Body>
            <Form.Group>
              <div
                className="scrollbar px-2"
                style={{ height: '350px', overflowY: 'scroll' }}
              >
                {scorecards.map(scorecard => (
                  <Form.Check
                    key={scorecard.id}
                    type="radio"
                    name="scorecards"
                    id={`scorecard2-${scorecard.id}`}
                    label={scorecard.name}
                    value={scorecard.id}
                    onChange={handleScorecardSelect}
                    checked={selectedScorecard === scorecard.id}
                  />
                ))}
              </div>
            </Form.Group>
          </Card.Body>
        </Card>
      </Col>
      <Col className="campaigns-column">
        <h3 className="px-2 text-secondary-darker">Campaigns</h3>
        <Card className="bg-body campaignassignment-card">
          <Card.Body>
            <Form.Group>
              <div
                className="scrollbar px-2"
                style={{ height: '350px', overflowY: 'scroll' }}
              >
                {campaigns.map(campaign => (
                  <Form.Check
                    id={`scorecard2-${campaign.id}`}
                    key={campaign.id}
                    type="checkbox"
                    label={`(${campaign.servicename}) - ${campaign.name}`}
                    onChange={() => handleCampaignSelect(campaign.id)}
                    checked={selectedCampaigns.has(campaign.id)}
                  />
                ))}
              </div>
            </Form.Group>
          </Card.Body>
        </Card>
        <div className="primary pt-3">
          <Button
            className="btn btn-primary btn-block px-4"
            onClick={handleAssign}
          >
            <FontAwesomeIcon icon={faAward} className="me-2 fs-8" />
            Assign scorecard to selected campaigns
          </Button>
        </div>
      </Col>
      <FormResultMessage
        show={modalVisible}
        message={message}
        messageType={messageType}
        logout={false}
        onClose={closeModal}
      />
    </Row>
  );
};

export default ScorecardAssignmentForm2;
